import { render, staticRenderFns } from "./Imperial.vue?vue&type=template&id=38ed6810"
import script from "./Imperial.vue?vue&type=script&lang=js"
export * from "./Imperial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports